const settingsConfig = {
  permissions: {
    usermanagement: 'usermanagement',
    workinghours: 'workinghours',
    serviceCenterconfiguration: 'servicecenterconfiguration',
    skillsmanager: 'skillsmanager',
    skillsassigner: 'skillsassigner',
    standalonemanager: 'standalonemanager',
    announcementmanager: 'announcementmanager',
    campaignmanager: 'campaignmanager',
    wipcodesmanagement: 'wipcodesmanagement',
  },
  types: {
    plant: 'plant',
    region: 'region',
    fse: 'fse',
  },
  skillMenuTypes: {
    fse: 'fse',
    master: 'master',
  },
  roles: {
    superuser: 'superuser',
    writeuser: 'writeuser',
  },
  defaultWorkingHours: {
    differentFromParentMessage: null,
    isDifferentFromParent: false,
    isInherited: false,
    isMerged: false,
    items: [
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 0,
        startOfWeek: false,
      },
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 1,
        startOfWeek: true,
      },
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 2,
        startOfWeek: false,
      },
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 3,
        startOfWeek: false,
      },
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 4,
        startOfWeek: false,
      },
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 5,
        startOfWeek: false,
      },
      {
        end: '17:30:00',
        isWorkingDay: false,
        start: '08:30:00',
        weekDay: 6,
        startOfWeek: false,
      },
    ],
    mergedWorkingHoursFrom: [],
    mergedWorkingHoursMessage: null,
  },
};

export default settingsConfig;
